var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27946 17.2503C5.97016 17.5725 5.97016 18.0948 6.27946 18.417C9.6817 21.961 15.1978 21.961 18.6001 18.417C22.0023 14.873 22.0023 9.12701 18.6001 5.583C15.1978 2.039 9.6817 2.039 6.27946 5.583C4.57749 7.35588 3.72678 9.68149 3.72777 12.0041L3.72775 13.8333C3.72775 14.289 4.08234 14.6583 4.51975 14.6583C4.95716 14.6583 5.31175 14.289 5.31176 13.8333L5.31177 12.0041C5.31088 10.1014 6.00664 8.20064 7.39951 6.74973C10.1832 3.85009 14.6964 3.85009 17.48 6.74973C20.2637 9.64937 20.2637 14.3506 17.48 17.2503C14.6964 20.1499 10.1832 20.1499 7.39951 17.2503C7.09022 16.9281 6.58875 16.9281 6.27946 17.2503Z",
    fill: "#0F1653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52019 12.6666L3.32022 11.4166C3.01093 11.0945 2.50946 11.0945 2.20017 11.4166C1.89087 11.7388 1.89087 12.2612 2.20017 12.5834L3.96016 14.4167C4.10869 14.5714 4.31014 14.6583 4.52019 14.6583C4.73024 14.6583 4.93169 14.5714 5.08022 14.4167L6.84022 12.5834C7.14952 12.2612 7.14952 11.7388 6.84022 11.4166C6.53093 11.0945 6.02946 11.0945 5.72017 11.4166L4.52019 12.6666Z",
    fill: "#0F1653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5601 7.5083C11.1227 7.5083 10.7681 7.87767 10.7681 8.3333L10.7681 12.9166C10.7681 13.3723 11.1227 13.7416 11.5601 13.7416L15.9601 13.7416C16.3975 13.7416 16.7521 13.3723 16.7521 12.9166C16.7521 12.461 16.3975 12.0916 15.9601 12.0916L12.3521 12.0916L12.3521 8.3333C12.3521 7.87767 11.9975 7.5083 11.5601 7.5083Z",
    fill: "#0F1653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.7806c738f53631facd58c2d971bb35dd.svg";
export { ForwardRef as ReactComponent };